import { ChangeEventHandler, ComponentProps, FC, useCallback } from 'react';

import { InputBaseWithOptions } from '../Input.type';
import { FieldWrapperOptionsGroup } from './FieldWrapper';
import { OptionField } from './OptionField';

type Props<InputValue = any> = Prettify<
  InputBaseWithOptions<InputValue> & Pick<ComponentProps<typeof OptionField>, 'type'>
>;

export const OptionFieldsGroup: FC<Props> = ({ type, onChange, onBlur, ...props }) => {
  const changeHandler: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      if (onChange) {
        // Handles the event differently depending on the current value type
        if (Array.isArray(props.value) || type === 'checkbox') {
          onChange(toggleValueInArray(event.target.value, Array.isArray(props.value) ? props.value : []));
        } else {
          onChange(event.target.checked ? event.target.value : '');
        }
      }
    },
    [props.value, onChange],
  );

  return (
    <FieldWrapperOptionsGroup {...props} type={type}>
      {props.options.map((option) => (
        <OptionField
          {...props}
          type={type}
          option={option}
          onChange={changeHandler}
          onBlur={onBlur}
          key={option.value}
        />
      ))}
    </FieldWrapperOptionsGroup>
  );
};

export const toggleValueInArray = (currentValue: string, inputValue: string[]): string[] => {
  let newInputValue = [...inputValue];
  if (inputValue.indexOf(currentValue) >= 0) {
    // Remove the value
    newInputValue = newInputValue.filter((value) => value !== currentValue);
  } else {
    // Add the value
    newInputValue.push(currentValue);
  }

  return newInputValue;
};
